const cloudinary = require('cloudinary-core');

module.exports = () => {

  const hero = document.querySelector('.hero');
  const backgroundBlendModeSupport = document.querySelector('html').classList.contains('backgroundblendmode');


  if (hero) {

    if (backgroundBlendModeSupport) {

      const heroCl = new cloudinary.Cloudinary({cloud_name: "creative-distillery", secure: true});
      const url = hero.dataset.url;
      const newUrl = heroCl.url(url, {
        type: 'fetch',
        format: 'auto'
      });
      const bgColor = hero.dataset.overlay;
      if ( bgColor ) {
        hero.style.backgroundImage = 'linear-gradient(' + bgColor + ',' + bgColor + '), url( ' + newUrl + ')';
      } else {
        hero.style.backgroundImage = 'url(' + newUrl + ')';
      }

    } else {

      const heroCl = new cloudinary.Cloudinary({cloud_name: "creative-distillery", secure: true});
      const url = hero.dataset.url;
      const bgColor = hero.dataset.overlay;

      const newUrl = heroCl.url(url, {
        effect: 'colorize:40',
        color: bgColor,
        type: 'fetch',
        format: 'auto'
      });

      hero.style.backgroundImage = 'url(' + newUrl + ')';

    }
  }
}
